import { render, staticRenderFns } from "./carouselBox.vue?vue&type=template&id=527ccbc6&scoped=true&"
import script from "./carouselBox.vue?vue&type=script&lang=js&"
export * from "./carouselBox.vue?vue&type=script&lang=js&"
import style0 from "./carouselBox.vue?vue&type=style&index=0&id=527ccbc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527ccbc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VHover,VImg})
